import { BaseApiRouteService } from "mrb/core";

class ProducerContentTreeApiRouteService extends BaseApiRouteService {
    constructor() {
        super("producers");
    }

    getContentTree(producerId) {
        return super.get(`${this.base}/{id}/content-tree`, producerId);
    }
}

export default ProducerContentTreeApiRouteService;
